import { Mail, Phone, MapPin, ExternalLink } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="section-dark-bg py-12 sm:py-16">
      <div className="section-container">
        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12 pb-12 border-b border-white/10">
          {/* About */}
          <div className="md:col-span-1">
            <img 
              src="https://files.manuscdn.com/user_upload_by_module/session_file/310519663035723669/aUVBGhJWWIApMxbQ.png" 
              alt="Purva Swanlake Logo" 
              className="h-16 mb-4 object-contain"
            />
            <p className="text-white/70 text-sm leading-relaxed">
              A premium residential community dedicated to providing excellent living standards and community services.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-white mb-4 text-lg border-b border-white/20 pb-2">Quick Links</h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a href="#about" className="text-white/70 hover:text-white hover:translate-x-1 transition-all duration-300 inline-flex items-center gap-2">
                  <span className="w-1 h-1 bg-blue-400 rounded-full"></span>
                  About
                </a>
              </li>
              <li>
                <a href="#community" className="text-white/70 hover:text-white hover:translate-x-1 transition-all duration-300 inline-flex items-center gap-2">
                  <span className="w-1 h-1 bg-blue-400 rounded-full"></span>
                  Community
                </a>
              </li>
              <li>
                <a href="#committee" className="text-white/70 hover:text-white hover:translate-x-1 transition-all duration-300 inline-flex items-center gap-2">
                  <span className="w-1 h-1 bg-blue-400 rounded-full"></span>
                  Leadership
                </a>
              </li>
              <li>
                <a href="#contact" className="text-white/70 hover:text-white hover:translate-x-1 transition-all duration-300 inline-flex items-center gap-2">
                  <span className="w-1 h-1 bg-blue-400 rounded-full"></span>
                  Contact
                </a>
              </li>
              <li>
                <a href="/bylaws" className="text-white/70 hover:text-white hover:translate-x-1 transition-all duration-300 inline-flex items-center gap-2">
                  <span className="w-1 h-1 bg-blue-400 rounded-full"></span>
                  📖 By-Laws
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-white mb-4 text-lg border-b border-white/20 pb-2">Contact</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-blue-400 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-white/60 text-xs uppercase tracking-wider">Email</p>
                  <a href="mailto:office.psaoa@gmail.com" className="text-white/80 hover:text-white transition-colors duration-300">
                    office.psaoa@gmail.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-blue-400 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-white/60 text-xs uppercase tracking-wider">Phone</p>
                  <a href="tel:+918838907864" className="text-white/80 hover:text-white transition-colors duration-300">
                    88389 07864
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Documents */}
          <div>
            <h3 className="font-bold text-white mb-4 text-lg border-b border-white/20 pb-2">Documents</h3>
            <div className="space-y-2.5">
              <a
                href="/bylaws"
                className="flex items-center gap-2 text-white/70 hover:text-white transition-colors duration-300 text-sm"
              >
                <ExternalLink className="w-4 h-4" />
                Read By-Laws
              </a>
              <a
                href="https://files.manuscdn.com/user_upload_by_module/session_file/310519663035723669/muYyzZhBDJMeSOiO.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/70 hover:text-white transition-colors duration-300 text-sm"
              >
                <ExternalLink className="w-4 h-4" />
                Download PDF
              </a>
            </div>
          </div>
        </div>

        {/* Address Section */}
        <div className="bg-gradient-to-r from-blue-600/10 to-blue-400/10 border border-blue-400/20 rounded-xl p-6 mb-12 pb-12 border-b-0">
          <div className="flex items-start gap-4">
            <div className="p-3 bg-blue-600/20 rounded-lg flex-shrink-0">
              <MapPin className="w-6 h-6 text-blue-400" />
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-white mb-2">Our Location</h3>
              <p className="text-white/80 text-sm mb-3 leading-relaxed">
                Purva Swanlake<br />
                1/367 A, Renugambal Nagar<br />
                OMR Road, Kelambakkam<br />
                Chengalpattu District<br />
                Tamil Nadu - 603103
              </p>
              <a
                href="https://maps.app.goo.gl/xu8WuqE42teJkirk8"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-all duration-300 transform hover:translate-x-1"
              >
                View on Google Maps
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="text-center border-t border-white/10 pt-8">
          <p className="text-white/80 mb-3 font-semibold">
            © {currentYear} Purva Swanlake Apartment Owners' Association (PSAOA). All rights reserved.
          </p>
          <p className="text-sm text-white/60 max-w-3xl mx-auto leading-relaxed">
            This is the official website of Purva Swanlake Apartment Owners Association (PSAOA). PSAOA functions in accordance with its registered By-Laws and the Tamil Nadu Societies Registration Act, 1975, and represents apartment owners for matters relating to common areas, facilities, and collective interests.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
